import React, { useEffect, useState } from 'react';
import Button from '@atlaskit/button';
import EmptyState from '@atlaskit/empty-state';
import { router, view } from '@forge/bridge';

import { CUSTOMFIELDS_ADMIN_PAGE_PATH } from '../constants';
import { GadgetContext } from '../model';

const ConfigEmptyState = () => {
    const [siteUrl, setSiteUrl] = useState('');

    useEffect(() => {
        document.body.style.height = '150px';
        void view.getContext().then(value => {
            setSiteUrl((value as GadgetContext).siteUrl);
        });
    }, []);

    return (
        <EmptyState
            header='No field'
            description='To use the gadget, create and configure the multilevel select custom field.'
            primaryAction={
                <Button
                    appearance='primary'
                    onClick={() => router.open(`${siteUrl}${CUSTOMFIELDS_ADMIN_PAGE_PATH}`)}
                >
                    Go to custom fields
                </Button>
            }
            width='wide'
        />
    );
};

export default ConfigEmptyState;
